"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = void 0;
const GetOrderDetails_1 = require("./GetOrderDetails");
const GetOrderList_1 = require("./GetOrderList");
const GetOrderStatusList_1 = require("./GetOrderStatusList");
const PostOrderAdd_1 = require("./PostOrderAdd");
const PostOrderChangeProducts_1 = require("./PostOrderChangeProducts");
const PostOrderChangeStatus_1 = require("./PostOrderChangeStatus");
const PostOrderDelete_1 = require("./PostOrderDelete");
const PostOrderEdit_1 = require("./PostOrderEdit");
__exportStar(require("./GetOrderDetails"), exports);
__exportStar(require("./GetOrderList"), exports);
__exportStar(require("./GetOrderStatusList"), exports);
__exportStar(require("./PostOrderAdd"), exports);
__exportStar(require("./PostOrderChangeProducts"), exports);
__exportStar(require("./PostOrderChangeStatus"), exports);
__exportStar(require("./PostOrderDelete"), exports);
__exportStar(require("./PostOrderEdit"), exports);
exports.Order = {
    GetOrderDetails: GetOrderDetails_1.GetOrderDetails,
    GetOrderList: GetOrderList_1.GetOrderList,
    GetOrderStatusList: GetOrderStatusList_1.GetOrderStatusList,
    PostOrderAdd: PostOrderAdd_1.PostOrderAdd,
    PostOrderChangeProducts: PostOrderChangeProducts_1.PostOrderChangeProducts,
    PostOrderChangeStatus: PostOrderChangeStatus_1.PostOrderChangeStatus,
    PostOrderDelete: PostOrderDelete_1.PostOrderDelete,
    PostOrderEdit: PostOrderEdit_1.PostOrderEdit
};
//# sourceMappingURL=index.js.map